import app from 'flarum/common/app';
import username from 'flarum/common/helpers/username';
import formatNumber from 'flarum/common/utils/formatNumber';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import extractText from 'flarum/common/utils/extractText';
const translationPrefix = 'fof-forum-statistics-widget.forum.navbar.';
const attributePrefix = 'fof-forum-statistics-widget.';
export default class ForumStatisticsWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs.state.user ??= null;
    this.attrs.state.isLoading ??= false;
    this.attrs.state.hasLoaded ??= false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (!this.attrs.state.hasLoaded) {
      this.load();
    }
  }
  isClassicLook() {
    return !!app.forum.attribute(attributePrefix + 'classicLook');
  }
  className() {
    const base = 'FoF-ForumStatisticsWidget';
    return this.isClassicLook() ? `${base} ${base}--classic` : base;
  }
  icon() {
    return 'fas fa-chart-bar';
  }
  title() {
    return extractText(app.translator.trans(translationPrefix + 'widget_title'));
  }
  description() {
    return '';
  }
  content() {
    if (this.attrs.state.isLoading) {
      return m(LoadingIndicator, null);
    }
    const items = this.items().toArray();
    if (items.length === 0) return null;
    if (this.isClassicLook()) {
      return m("div", {
        className: "ForumStatistics containerNarrow"
      }, m("div", {
        className: "row"
      }, m("h2", null, m("i", {
        className: "fas fa-chart-bar"
      }), " ", app.translator.trans(translationPrefix + 'widget_title')), m("div", null, m("ul", {
        id: "ForumStatisticsList"
      }, items))));
    }
    return m("ul", {
      className: "ForumStatisticsList"
    }, items);
  }
  items() {
    const items = new ItemList();
    const discussionsCount = app.forum.attribute(attributePrefix + 'discussionsCount');
    const postsCount = app.forum.attribute(attributePrefix + 'postsCount');
    const usersCount = app.forum.attribute(attributePrefix + 'usersCount');
    const lastUserId = app.forum.attribute(attributePrefix + 'lastUserId');
    if (discussionsCount) {
      items.add('discussions_count', m("li", null, app.translator.trans(translationPrefix + 'discussions_count', {
        discussionsCount: formatNumber(discussionsCount)
      })));
    }
    if (postsCount) {
      items.add('posts_count', m("li", null, app.translator.trans(translationPrefix + 'posts_count', {
        postsCount: formatNumber(postsCount)
      })));
    }
    if (usersCount) {
      items.add('users_count', m("li", null, app.translator.trans(translationPrefix + 'users_count', {
        usersCount: formatNumber(usersCount)
      })));
    }

    // [swtor-polska.pl] goście online (liczba odświeżana przez forum/index.ts)
    if (app.forum.attribute(attributePrefix + 'showGuestsOnline') !== false) {
      const guestsCount = app.fofGuestsOnline ?? app.forum.attribute(attributePrefix + 'guestsOnline') ?? 0;
      items.add('guests_online', m("li", null, app.translator.trans(translationPrefix + 'guests_online', {
        guestsCount: formatNumber(guestsCount)
      })));
    }
    const user = this.attrs.state.user;
    if (lastUserId && user) {
      items.add('latest_member', m("li", null, app.translator.trans(translationPrefix + 'latest_member'), ' ', m(Link, {
        href: app.route('user', {
          username: user.slug()
        })
      }, m("strong", null, username(user)))));
    }
    return items;
  }
  load() {
    const lastUserId = app.forum.attribute(attributePrefix + 'lastUserId');
    if (!lastUserId) {
      this.attrs.state.hasLoaded = true;
      return;
    }
    this.attrs.state.isLoading = true;
    app.store.find('users', lastUserId).then(user => {
      this.attrs.state.user = user;
    })
    // The counts still render without the latest member; app.request has already reported the error.
    .catch(() => {}).finally(() => {
      this.attrs.state.isLoading = false;
      this.attrs.state.hasLoaded = true;
      m.redraw();
    });
  }
}
flarum.reg.add('fof-forum-statistics-widget', 'common/components/ForumStatisticsWidget', ForumStatisticsWidget);